
import { Stack } from 'ui/stack';

import Button from 'components/partials/button/button';
import Modal from 'components/partials/modal/modal';

interface RemoveCustomPopulationModalProps {
  onConfirm: () => void;
  onClose: () => void;
}

const RemoveCustomPopulationModal = ({
  onConfirm,
  onClose,
}: RemoveCustomPopulationModalProps) => {
  const footer = (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 2 }}>
      <Button
        type="button"
        variant="brand-filled"
        size="md"
        onClick={onConfirm}
        data-testid="confirm-remove-custom-population-button"
      >
        Remove
      </Button>
      <Button
        type="button"
        variant="brand-outlined"
        size="md"
        onClick={onClose}
        data-testid="cancel-remove-custom-population-button"
      >
        Cancel
      </Button>
    </Stack>
  );

  return (
    <Modal
      headerText="Remove custom admit adjustments populations"
      text="Students of this population will be re-evaluated against the remaining populations. Are you sure?"
      onCloseCallback={onClose}
      showCloseButton
      disableBackdropClick
      skipUnmountOnClose
      footer={footer}
      primaryAction={{ onClick: onConfirm }}
      modalClassName="!w-[640px] p-5"
      headerClassName="text-2xl font-bold"
      textClassName="text-base pr-3"
      data-testid="remove-custom-population-modal"
    />
  );
};

export default RemoveCustomPopulationModal;
